export default "__VITE_ASSET__ecd7bf0a__"